import React, { useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { HouseRuleInput, HouseRuleItem, HouseRulesExamples } from "../components/HouseRules";

var Modal = require("react-bootstrap-modal");

export function HouseRules({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  save,
  updating,
}) {
  const [houseRules, setHouseRules] = useState(formData["houseRules"] || []);
  const [rule, setRule] = useState("");

  const [editingIndex, setEditingIndex] = useState(null);
  const [editingText, setEditingText] = useState("");

  const valueRef = useRef(formData);
  const elementRef = useRef(null);

  
  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])
  
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const countWords = (text) => {
    if (!text.trim()) return 0;
    return text.trim().split(/\s+/).length;
  };
  

  const handleRules = (curr) => {
    if (curr) {
      setHouseRules([...houseRules, curr]);
      setRule("");
      valueRef.current = { ...formData, houseRules: [...houseRules, curr] };
    
    }
  };

  const deleteRule = (id) => {
    const ruleArr = [...houseRules];
    ruleArr.splice(id, 1);
    setHouseRules([...ruleArr]);
    valueRef.current = { ...formData, houseRules: ruleArr };
  };

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditingText(houseRules[index]);
  };

  const saveEdit = () => {
    const trimmedText = editingText.trim();
    if (trimmedText && countWords(trimmedText) >= 1 && countWords(trimmedText) <= 100) {
      const updatedRules = [...houseRules];
      updatedRules[editingIndex] = trimmedText;
      setHouseRules(updatedRules);
      cancelEdit();
    }
  };

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditingText("");
  };


  const handleNextStep = () => {
    setFormData(valueRef.current);
    if (houseRules.length) {
      setTimeout(() => {
        save({ houseRules });
        onNext();
      }, 0); 
    }
  };

  return (
    <div className={className}  ref={elementRef}>
      <div className=" tw-min-h-[60vh] ">
        <div className="row gx-5">
          <h4 className="mb-5 h-min tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              3
            </span>{" "}
            House Rules
          </h4>
          <div className="col-lg-6">
            {Boolean(houseRules.length) ? (
              <div className="mb-2">
                {houseRules.map((curr, index) => {
                  return <HouseRuleItem     
                  index={index}
                  rule={curr}
                  editingIndex={editingIndex}
                  editingText={editingText}
                  setEditingText={setEditingText}
                  startEditing={startEditing}
                  cancelEdit={cancelEdit}
                  saveEdit={saveEdit}
                  deleteRule={deleteRule}
                  wordLimit={100}
                  />
              })}
              </div>
            ) : (
              <p className="tw-mb-4 tw-text-center tw-text-gray-600 tw-text-xl ">
                No rules added
              </p>
            )}
            <div className="mb-2 tw-flex tw-items-center">
              <HouseRuleInput rule={rule} setRule={setRule} wordLimit={100} handleSave={() => handleRules(rule)}/>
              <button
                onClick={() => handleRules(rule)}
                type="button"
                className="btn btn-sm btn-primary m-2 "
              >
                Add
              </button>
            </div>
          </div>
          <HouseRulesExamples/>
        </div>
      </div>
      <div>
        <button
          onClick={onPrev}
          type="button"
          className="btn btn-secondary mx-2  tw-mb-2"
        >
          Prev
        </button>
        <button
          onClick={handleNextStep}
          type="submit"
          className="btn btn-secondary mx-2 tw-mb-2"
          disabled={updating}
        >
          {updating ? "Updating ..." : "Save & Next"}
        </button>
      </div>
    </div>
  );
}

export const validateRules = (formData) => {

  const {houseRules} = formData
  const errors = [];

  if (!houseRules) {
    errors.push({
      error: "House rules field is required",
      errorType: 'houseRules'
    })
    return { errors, isValid: false };
  }


  if (houseRules.length === 0) {
    errors.push({
      error: "No house rules have been added",
      errorType: 'houseRules'
    })
    return { errors, isValid: false };
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
  };
};